import { render, staticRenderFns } from "./_column.vue?vue&type=template&id=20133648&scoped=true&"
import script from "./_column.vue?vue&type=script&lang=js&"
export * from "./_column.vue?vue&type=script&lang=js&"
import style0 from "./_column.vue?vue&type=style&index=0&id=20133648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20133648",
  null
  
)

export default component.exports